import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/v1';

// La cle API n'est jamais embarquee dans le bundle : l'administrateur la saisit
// a la connexion et elle ne vit que dans la session de l'onglet.
const STORAGE_KEY = 'signature_admin_api_key';

export function getApiKey(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setApiKey(key: string): void {
  sessionStorage.setItem(STORAGE_KEY, key);
}

// Session ouverte par code e-mail (et non par cle d'API) : donne acces a la gestion des cles et a la facturation
const SESSION_FLAG = 'signature_admin_session';

export function setSession(token: string): void {
  sessionStorage.setItem(STORAGE_KEY, token);
  sessionStorage.setItem(SESSION_FLAG, '1');
}

export function isSession(): boolean {
  try {
    return sessionStorage.getItem(SESSION_FLAG) === '1';
  } catch {
    return false;
  }
}

export function clearApiKey(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(SESSION_FLAG);
  } catch {
    // stockage indisponible : rien a effacer
  }
}

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((request) => {
  const key = getApiKey();
  if (key) {
    request.headers.Authorization = `Bearer ${key}`;
  }
  return request;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearApiKey();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

/**
 * Verifie une cle API aupres de l'API avant de l'enregistrer.
 */
export async function validateApiKey(key: string): Promise<boolean> {
  try {
    await axios.get(`${API_BASE_URL}/documents`, {
      params: { limit: 1 },
      headers: { Authorization: `Bearer ${key}` },
      timeout: 15000,
    });
    return true;
  } catch {
    return false;
  }
}

/** Demande l'envoi d'un code de connexion par e-mail. */
export async function requestLoginCode(email: string): Promise<void> {
  await axios.post(`${API_BASE_URL}/account/login/request`, { email }, { timeout: 15000 });
}

/** Echange le code contre une session. */
export async function verifyLoginCode(email: string, code: string): Promise<void> {
  const response = await axios.post(`${API_BASE_URL}/account/login/verify`, { email, code }, { timeout: 15000 });
  setSession(response.data.token);
}

export default api;
